// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  background: rgb(248, 248, 248);
  border: 1px solid rgb(220, 220, 220);
  border-radius: 4px 0 0 4px;
  border-right: 0;
`

const InputGroupAddon = ({
  children,
  style
}: {
  children?: any,
  style?: Object
}) => <Component style={style}>{children}</Component>

export default InputGroupAddon



// WEBPACK FOOTER //
// ./src/components/InputGroupAddon/index.js